import { ErrorType } from '../../../models/HttpError';
import { AppState } from '../../../redux/reducers';
import { EmailViewModel } from '../../../models/Entities/Person/Email/EmailModels';

// store
import * as PersonEmailsStore from '../../../redux/middleware/PersonEmails.Middleware';

export interface IProps {
  PersonId: number;
}

interface ConnectedProps {
  isLoading: boolean | undefined;
  isLoadingSuccessfully: boolean | undefined;
  failOnLoading: boolean | undefined;
  isDeleting: boolean | undefined;
  failOnDeleting: boolean | undefined;
  error: ErrorType | undefined;
  emails: EmailViewModel[];
}

interface DispatchProps {
  GetEmailsByPersonId: typeof PersonEmailsStore.actionCreators.GetEmailsByPersonId;
  DeleteEmail: typeof PersonEmailsStore.actionCreators.DeleteEmail;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => ({
  isLoading: state.PersonEmails?.isLoadingAll,
  isLoadingSuccessfully: state.PersonEmails?.successLoadingAll,
  failOnLoading: state.PersonEmails?.failOnLoadingAll,
  isDeleting: state.PersonEmails?.isDeletingOne,
  failOnDeleting: state.PersonEmails?.failOnDeletingOne,
  error: state.PersonEmails?.error,
  emails: (state.PersonEmails?.list ?? []).filter(
    (item: EmailViewModel) => item.personId === ownProps.PersonId
  ),
  ...ownProps
});

export const mapDispatchToProps = {
  ...PersonEmailsStore.actionCreators
};
